angular.module('zc.zenclerkS')

  .factory('Behavior', Behavior);

Behavior.$inject = ['$state', 'MongoHistory'];
function Behavior($state, MongoHistory) {

  const service = {
    current: {
      apikey: undefined,
      usid: undefined,
      sid: undefined,
      histories: [],
      playTime: undefined,
      isPlaying: false,
      speedFactor: undefined
    },
    sessionSearchQuery: {
      device: { pc: true, sp: true, tablet: true },
      use_min_history_count: true,
      use_max_history_count: false,
      min_history_count: 5,
      max_history_count: 10,
      use_min_conversion_count: false,
      use_max_conversion_count: false,
      min_conversion_count: 0,
      max_conversion_count: 0
    },
    defaultSessionSearchQuery: {
      device: { pc: true, sp: true, tablet: true },
      use_min_history_count: true,
      use_max_history_count: false,
      min_history_count: 5,
      max_history_count: 10,
      use_min_conversion_count: false,
      use_max_conversion_count: false,
      min_conversion_count: 0,
      max_conversion_count: 0
    },
    sessionSearchTime: {},
    defaultSessionSearchTime: {},
    isAutoplay: false,
    usidPlaylist: [],

    getNextAutoplayUsid,
    autoplayUsid,
    getNextHistorySid,
  };

  function getNextAutoplayUsid() {
    const currentIdx = service.usidPlaylist.indexOf(service.current.usid);
    return service.usidPlaylist[currentIdx + 1];
  }

  function autoplayUsid(usid) {
    // get first sid
    return MongoHistory.find({ apikey: service.current.apikey, _usid: usid })
      .then(histories => {
        service.current.histories = histories;
        if(service.current.histories[0]) {
          $state.go('viz.site.session.player', { apikey: service.current.apikey, usid: service.current.usid, sid: service.current.histories[0]._id });
        }
      });
  }

  function getNextHistorySid(sid) {
    if(service.current.histories.length === 0) { return null }
    for(let i = 0; i < service.current.histories.length; i++) {
      const item = service.current.histories[i];
      const itemNext = service.current.histories[i + 1];
      if(item._id === sid && itemNext) {
        return _.get(service.current.histories, '_id');
      }
    }
    return undefined;
  }

  return service;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/behavior.service.js